import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';

// Create Socket Context
const SocketContext = createContext(null);

// Socket Provider Component
export const SocketProvider = ({ children }) => {
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // Connect to the socket server
    socketRef.current = io("https://api.experts4u.in/", {
      transports: ["websocket"],  // Force WebSocket
      forceNew: true,             // Create new connection
      reconnectionAttempts: 10,   // Retry 10 times
      timeout: 10000,
    });

    // Event: Connected to server
    socketRef.current.on('connect', () => {
      setIsConnected(true);
    });

    // Event: Disconnected from server
    socketRef.current.on('disconnect', () => {
      console.log('Socket disconnected');
      setIsConnected(false);
    });

    // Event: Receive notifications
    socketRef.current.on('new_notification', (notification) => {
      console.log('New Notification:', notification);
      setNotifications((prev) => [...prev, notification]);
    });

    // Cleanup function
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, []);

  // Function to send job ID to the server
  const sendJobId = (jobId) => {
    if (socketRef.current && isConnected) {
      socketRef.current.emit('send_job_id', jobId);
      console.log(`Job ID ${jobId} sent to server`);
    } else {
      console.warn('Socket is not connected. Cannot send job ID.');
    }
  };

  return (
    <SocketContext.Provider value={{ socket: socketRef.current, isConnected, notifications, sendJobId }}>
      {children}
    </SocketContext.Provider>
  );
};

// Custom Hook to use Socket
export const useSocket = () => {
  return useContext(SocketContext);
};
